// Imports
//=require jquery/dist/jquery.min.js
//=require jquery-validation/dist/jquery.validate.min.js
//=require ../source/js/jQuery-material-form-fields-master/js/jquery.material.form.min.js
//=require jquery-mask-plugin/dist/jquery.mask.min.js
//=require slick-carousel/slick/slick.min.js

// DOM
var MyApp = {
    login: function () {
        $('.login-form').materialForm();
        $('.login-form').validate({
            errorPlacement: function (error, element) { },
            errorElement: 'div',
            success: function (label, element) {
                label.parent().removeClass('error');
                label.remove();
            }
        });
    },
    menu: {
        open: function () {
            $('.js-menu-button').click(function (event) {
                event.preventDefault();
                $('.main-nav__container').toggleClass('main-nav__container_open');
            });
        },
        submenu: function () {
            $('.main-nav__link').click(function (event) {
                if ($(this).attr('href')==='#') {
                    event.preventDefault();
                    if ($(this).hasClass('main-nav__link_active')) {
                        $(this).removeClass('main-nav__link_active').next('.main-nav__sublist-wrapper').removeClass('main-nav__sublist-wrapper_open');
                    } else {
                        $('.main-nav__link').removeClass('main-nav__link_active');
                        $('.main-nav__sublist-wrapper').removeClass('main-nav__sublist-wrapper_open');
                        $(this).addClass('main-nav__link_active').next('.main-nav__sublist-wrapper').toggleClass('main-nav__sublist-wrapper_open');
                    }
                }
            });
        },
        sublist: function () {
            $('.main-nav__subtitle').click(function (event) {
                if ($(this).attr('href')==='#') {
                    event.preventDefault();
                    $(this).next('.main-nav__sublist_droppable').toggleClass('main-nav__sublist_droppable_open');
                }
            });
        },
        hideSublist: function () {
            $(document).on('click', function (event) {
                if (!$(event.target).closest('.main-nav__list').length) {
                    $('.main-nav__sublist-wrapper').removeClass('main-nav__sublist-wrapper_open');
                }
            });
        },
        hideMenu: function () {
            $(document).on('click', function (event) {
                if (!$(event.target).closest('.menu-button').length && !$(event.target).closest('.main-nav__list').length) {
                    $('.main-nav__container').removeClass('main-nav__container_open');
                }
            });
        }
    },
    onlyNumbers : function() {
        $('.only-numbers').on('keypress', function(event) {
            var numbers = /[0-9]/g;
            var key = String.fromCharCode(event.which);
            if ($.inArray(event.keyCode) >= 0 || numbers.test(key)) {
                return true;
            }
            return false;
        });
    },
    onlyLetters : function () {
        $('.only-letters').on('keypress', function(event) {
            var englishAlphabetAndWhiteSpace = /[A-Za-z- ]/g;
            var arr_latin_character = [8,37,39,193,225,200,232,205,237,211,243,218,250,209,241];
            var key = String.fromCharCode(event.which);
            if ($.inArray(event.keyCode, arr_latin_character) >= 0 || englishAlphabetAndWhiteSpace.test(key)) {
                return true;
            }
            return false;
        });
    },
    quote : {
        quoteWidget : function () {
            // method for email
            jQuery.validator.addMethod('validEmail', function (value, element) {
                if (value == '')
                    return true;
                var temp1;
                temp1 = true;
                var ind = value.indexOf('@');
                var str2 = value.substr(ind + 1);
                var str3 = str2.substr(0, str2.indexOf('.'));
                if (str3.lastIndexOf('-') == (str3.length - 1) || (str3.indexOf('-') != str3.lastIndexOf('-')))
                    return false;
                var str1 = value.substr(0, ind);
                if ((str1.lastIndexOf('_') == (str1.length - 1)) || (str1.lastIndexOf('.') == (str1.length - 1)) || (str1.lastIndexOf('-') == (str1.length - 1)))
                    return false;
                str = /(^[a-zA-Z0-9]+[\._-]{0,1})+([a-zA-Z0-9]+[_]{0,1})*@([a-zA-Z0-9]+[-]{0,1})+(\.[a-zA-Z0-9]+)*(\.[a-zA-Z]{2,3})$/;
                temp1 = str.test(value);
                return temp1;
            }, 'Please enter a valid email address.');

            $('.quote-widget__form').validate({
                errorPlacement: function(error, element) {
                    error.insertAfter(element);
                },
                errorElement:'span',
                errorClass: 'form__error',
                rules:{
                    'first-name':{minlength:2},
                    'last-name':{minlength:2},
                    email: { minlength: 3, maxlength: 255, validEmail: true},
                    phone: { minlength: 12, maxlength: 12},
                    zipcode:{ digits: true, minlength:5, maxlength:5}
                },
                messages: {
                    phone: {
                        minlength: "You must enter 10 digits",
                        maxlength: "You must enter 10 digits",
                    },
                },
                submitHandler: function(form) {

                    $('.quote-widget__form').addClass('form_loading');
                    $('.error-zipcode').html('');

                    $.getJSON('https://www.freewaylms.com/controller/validation-zipcode.php?callback=?',{zipcode:$('#zipcode').val(), method :'json', return_data:'true'}, function(data){
                        if (data.response == 1) {
                            $('#VisitorState').val(data.data.state);
                            $('#city').val(data.data.city);
                            $('.quote-widget__form').removeClass('form_loading');
                            $('.error-zipcode').html('');
                            form.submit();
                        } else {
                            $('.error-zipcode').append('<span class="form__error">Please enter a valid zip code.</span>');
                            $('.quote-widget__form').removeClass('form_loading');
                        }
                    });
                }
            });
        },
        quoteForm: function () {
            // method for email
            jQuery.validator.addMethod('validEmail', function (value, element) {
                if (value == '')
                    return true;
                var temp1;
                temp1 = true;
                var ind = value.indexOf('@');
                var str2 = value.substr(ind + 1);
                var str3 = str2.substr(0, str2.indexOf('.'));
                if (str3.lastIndexOf('-') == (str3.length - 1) || (str3.indexOf('-') != str3.lastIndexOf('-')))
                    return false;
                var str1 = value.substr(0, ind);
                if ((str1.lastIndexOf('_') == (str1.length - 1)) || (str1.lastIndexOf('.') == (str1.length - 1)) || (str1.lastIndexOf('-') == (str1.length - 1)))
                    return false;
                str = /(^[a-zA-Z0-9]+[\._-]{0,1})+([a-zA-Z0-9]+[_]{0,1})*@([a-zA-Z0-9]+[-]{0,1})+(\.[a-zA-Z0-9]+)*(\.[a-zA-Z]{2,3})$/;
                temp1 = str.test(value);
                return temp1;
            }, 'Please enter a valid email address.');

            $('.quote-form form').validate({
                errorPlacement: function (error, element) { },
                errorElement: 'span',
                errorClass: 'quote-form__error',
                rules: {
                    'first-name': { minlength: 2 },
                    'last-name': { minlength: 2 },
                    email: { minlength: 3, maxlength: 255, validEmail: true },
                    phone: { minlength: 12, maxlength: 12 },
                    zipcode: { digits: true, minlength: 5, maxlength: 5 },
                    date: { minlength: 10, maxlength: 10 },
                    birthdate: { minlength: 10, maxlength: 10 }
                },
                messages: {
                    phone: {
                        minlength: "You must enter 10 digits",
                        maxlength: "You must enter 10 digits"
                    },
                    date: {
                        minlength: "You must enter a valid date (mm/dd/yyyy)",
                        maxlength: "You must enter a valid date (mm/dd/yyyy)"
                    },
                    birthdate: {
                        minlength: "You must enter a valid date (mm/dd/yyyy)",
                        maxlength: "You must enter a valid date (mm/dd/yyyy)"
                    }
                },
                submitHandler: function (form) {                    
                    $('.quote-form form').addClass('form_loading');
                    $('.error-zipcode').html('');

                    $.getJSON('https://www.freewaylms.com/controller/validation-zipcode.php?callback=?', { zipcode: $('#zipcode').val(), method: 'json', return_data: 'true' }, function (data) {
                        if (data.response == 1) {
                            $('#VisitorState').val(data.data.state);
                            $('#city').val(data.data.city);
                            $('.quote-form form').removeClass('form_loading');
                            $('.error-zipcode').html('');
                            form.submit();
                        } else {
                            $('.error-zipcode').append('<span class="form__error">Please enter a valid zip code.</span>');
                            $('.quote-form form').removeClass('form_loading');
                        }
                    });

                }
            });

            $("#DependentsCount").change(function (event) {
                for (var i = 1; i <= 8; i++) {
                    if (i > $(this).val())
                        $("#adult" + i).val('').closest('.adult').slideUp();
                    else if ($("#adult" + i).closest('.adult').is(":hidden"))
                        $("#adult" + i).closest('.adult').slideDown();
                }
            });
        }
    },
    contact: {
        contactForm: function () {
            // method for email
            jQuery.validator.addMethod('validEmail', function (value, element) {
                if (value == '')
                    return true;
                var temp1;
                temp1 = true;
                var ind = value.indexOf('@');
                var str2 = value.substr(ind + 1);
                var str3 = str2.substr(0, str2.indexOf('.'));
                if (str3.lastIndexOf('-') == (str3.length - 1) || (str3.indexOf('-') != str3.lastIndexOf('-')))
                    return false;
                var str1 = value.substr(0, ind);
                if ((str1.lastIndexOf('_') == (str1.length - 1)) || (str1.lastIndexOf('.') == (str1.length - 1)) || (str1.lastIndexOf('-') == (str1.length - 1)))
                    return false;
                str = /(^[a-zA-Z0-9]+[\._-]{0,1})+([a-zA-Z0-9]+[_]{0,1})*@([a-zA-Z0-9]+[-]{0,1})+(\.[a-zA-Z0-9]+)*(\.[a-zA-Z]{2,3})$/;
                temp1 = str.test(value);
                return temp1;
            }, 'Please enter a valid email address.');

            $('.contact-form').validate({
                errorPlacement: function (error, element) {},
                errorElement: 'span',
                errorClass: 'contact-form__error',
                rules: {
                    'first-name': { minlength: 2 },
                    'last-name': { minlength: 2 },
                    email: { minlength: 3, maxlength: 255, validEmail: true },
                    phone: { minlength: 12, maxlength: 12 },
                    zipcode: { digits: true, minlength: 5, maxlength: 5 }
                },
                messages: {
                    phone: {
                        minlength: "You must enter 10 digits",
                        maxlength: "You must enter 10 digits",
                    },
                },
                submitHandler: function (form) {
                    $('.contact-form').addClass('form_loading');
                    form.submit();
                }
            });
        }
    },
    notFound: function() {
        $('.not-found-form').validate({
            errorPlacement: function (error, element) {},
            errorElement: 'span',
            errorClass: 'not-found-form__error',
        });
    },
    phone: function () {
        $('.quote-form__input_telephone').mask('000-000-0000');
    },
    date: function () {
        $('.quote-form__input_date').mask('00/00/0000');
    },
    home: {
        featuresSlider: function() {
            $('.js-home-features__slider').slick({
                prevArrow: '.js-home-features__control_prev',
                nextArrow: '.js-home-features__control_next',
                adaptiveHeight: true,
                mobileFirst: true,
                responsive: [{
                    breakpoint: 1,
                    settings: {
                        slidesToShow: 1
                    }
                },{
                    breakpoint: 830,
                    settings: {
                        slidesToShow: 3,
                        infinite: false
                    }
                }]
            });
        },
        testimoniesSlider: function() {
            $('.js-home-testimonies__slider').slick({
                prevArrow: '.js-home-testimonies__control_prev',
                nextArrow: '.js-home-testimonies__control_next',
                adaptiveHeight: true
            });
        }
    },
    featuresTab : {
        showTab: function () {
            $('.js-office-features__h2').click(function (event) {
                event.preventDefault();
                $('.js-office-features__h2').removeClass('office-features__h2_active');
                $(this).addClass('office-features__h2_active');
            })
        }
    },
    footer: {
        submenu: function () {
            $('.js-site-footer__subtitle').click(function (event) {
                if ($(this).attr('href') === '#') {
                    event.preventDefault();
                    $('.site-footer__sublist').removeClass('site-footer__sublist_open');
                    $(this).next('.site-footer__sublist').toggleClass('site-footer__sublist_open');
                }
            });
        }
    },
    blog: {
        categories: function () {
            $('.categories-widget__item_more').click(function (event) {
                event.preventDefault();
                $('.categories-widget__item_hidden').fadeIn();
                $(this).fadeOut();
            });
        }
    }
}

// On ready

$(function () {

    MyApp.menu.open();
    MyApp.menu.submenu();
    MyApp.menu.sublist();
    MyApp.menu.hideSublist();
    MyApp.menu.hideMenu();
    MyApp.footer.submenu();

    if ($('.login-form').length) {
        MyApp.login();
    }

    if ($('.only-numbers').length) {
        MyApp.onlyNumbers();
    }

    if ($('.only-letters').length) {
        MyApp.onlyLetters();
    }

    if ($('.quote-form__input_telephone').length) {
        MyApp.phone();
    }

    if ($('.quote-form__input_date').length) {
        MyApp.date();
    }

    if ($('.quote-widget__form').length) {
        MyApp.quote.quoteWidget();
    }

    if ($('.quote-form').length) {
        MyApp.quote.quoteForm();
    }

    if ($('.contact-form').length) {
        MyApp.contact.contactForm();
    }

    if ($('.js-home-features__slider').length) {
        MyApp.home.featuresSlider();
    }

    if ($('.js-home-testimonies__slider').length) {
        MyApp.home.testimoniesSlider();
    }

    if ($('.js-office-features__h2').length) {
        MyApp.featuresTab.showTab();
    }

    if ($('.not-found-form').length) {
        MyApp.notFound();
        
    }

    if ($('.categories-widget').length) {
        MyApp.blog.categories();
    }

    if(jQuery(".js-page-see-more-posts__button").length){
        jQuery(".js-page-see-more-posts__button").on("click", function(e) {
            e.preventDefault();
            jQuery( this ).prop( "disabled", true );
            //console.log("get data");
            var cat = jQuery(".js-page-see-more-posts__button").attr('data-cat');
            var paged = jQuery(".js-page-see-more-posts__button").attr('data-paged');
            var max_paged = jQuery(".js-page-see-more-posts__button").attr('data-max_paged');
            var target_url = window.location.origin +"/blog/wp-json/wp/v2/posts/";
            var target_url_acf = window.location.origin +"/blog/wp-json/acf/v3/posts/";
            var postperpage = jQuery(".js-page-see-more-posts__button").attr('data-postperpage');
            var featuredtagid = jQuery(".js-page-see-more-posts__button").attr('data-featuredtagid');
            var parametros =""
            parametros+="?page="+paged+"&per_page="+postperpage+"&tags_exclude="+featuredtagid;
            if(cat.length>0){
                parametros+="&categories="+cat;
            }
            var acf_data ="";
            
            //jQuery.getJSON(target_url+parametros,function(data) {
                jQuery.ajax({
                    url:target_url+parametros,
                    dataType: 'json',
                    async:false,
                    success:function(data){ 
                    //console.log(data); 
                    //console.log(target_url+parametros);
                    var response_HTML = "";
                    var acf_data = "";
                    var categories_url =  window.location.origin +"/blog/wp-json/wp/v2/categories/";
                    //$format_data = jQuery.parseJSON(data);
                    
                        //console.log(acf_data);
                        jQuery.each(data,function(index,value){
                            //console.log("cat id = " + value.categories[0]);
                            var category_id = value.categories[0];
                            var thumb_url = (value.acf.post_image_sm_jpg==null)?"":value.acf.post_image_sm_jpg.url;
                            //console.log(thumb_url);
                             
                            if(category_id !== null){
                                jQuery.ajax({
                                    url:categories_url+category_id,
                                    dataType: 'json',
                                    async:false,
                                    success:function(cat_data){
                                    //console.log(cat_data); 
                                    var d = moment(value.date).format("MMMM Do YYYY"); 
                                    //console.log(d);
                                    var excerpt_tmp = value.excerpt.rendered;
                                    excerpt_tmp = excerpt_tmp.substr(0,150)+"[...]";
                                    response_HTML="<li class='blog-list__item'> \
                                    <article class='blog-list__article'> \
                                            <div class='blog-list__image'> \
                                                <a href='"+value.link+"'> \
                                                    <picture class=''> \
                                                    <source data-sizes='auto' data-srcset='"+thumb_url+"' type='image/jpeg'>\
                                                    <img class='' src='"+thumb_url+"' alt='' title='"+value.title.rendered+"'>\
                                                    </picture> \
                                                </a>\
                                            </div> \
                                            <div class='blog-list__content'> \
                                                <h1><a href='"+value.link+"'>"+value.title.rendered+"</a></h1> \
                                                <div class='blog-list__info'> \
                                                    <div class='blog-list__tags'>"+cat_data.name+" </div><span>- </span> \
                                                    <div class='blog-list__date'>"+d+"</div> \
                                                </div> \
                                                "+excerpt_tmp+" \
                                                <a class='blog-list__more' href='"+value.link+"'>Read more</a>\
                                            </div> \
                                        </article> </li>"; 
                                        
                                        jQuery("ul.blog__list.blog-list").append(response_HTML);
                                    }
                                });
                            }
                            //console.log(index);
                        });
                    //});
                    paged = parseInt(paged) + 1;
                    //console.log(paged); 
                    //console.log(max_paged);

                    if (paged > max_paged) {
                        jQuery(".js-page-see-more-posts__button").hide();
                    } 
                    jQuery(".js-page-see-more-posts__button").attr('data-paged', paged);
                    jQuery(".js-page-see-more-posts__button").prop( "disabled", false );
                }
            }); 
            /*
            $.ajax({
                //url: window.location.origin + "/api/knowledge/get-paged-posts.php",
                url: target_url,
                data: "cat=" + cat + "&paged=" + paged,
                type: "GET",
                //dataType: "jsonp", 
                success: function(data) {
                    if (data.length > 0) {
                        paged = parseInt(paged) + 1;
                        if (paged > max_paged) {
                            jQuery(".js-page-see-more-posts__button").hide();
                        }
                        jQuery(".js-page-see-more-posts__button").attr('data-paged', paged);
                        jQuery(".c-kc-teaser__item.c-kc-teaser__item--50.c-kc-teaser__item--33:last").after(data);
                        jQuery(".js-page-see-more-posts__button").prop( "disabled", false );
                    }
                    //console.log(data);
                    //console.log("get data");
    
                }
            });
            */
        })
    }
});

var osanoTrigger = {
    init() {
        var triggers = document.querySelectorAll('.js-osano-trigger');
        triggers.forEach(trigger => {
            trigger.addEventListener('click', event => {
                event.preventDefault();
                Osano.cm.showDoNotSell();
                var closeButtonDialog = document.querySelector('.osano-cm-info-dialog .osano-cm-close');
                closeButtonDialog?.focus();
            });
        });
    }
};

window.addEventListener('load', event => {
    osanoTrigger.init();
});
